<template>
  <div class="MarketMain">
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
        position: relative;
      "
    >
      <div class="listSel">
        <p>分类:</p>
        <van-dropdown-menu active-color="#CC4545" :overlay="false">
          <van-dropdown-item
            v-model="value"
            :options="CategoryList"
            @change="changeType(value)"
          />
        </van-dropdown-menu>
      </div>
      <div class="listSel2">
        <p>店铺:</p>
        <van-dropdown-menu active-color="#CC4545" :overlay="false">
          <van-dropdown-item
            v-model="value2"
            :options="BrandList"
            @change="changeTop(value2)"
            class="right"
          />
        </van-dropdown-menu>
      </div>
    </div>
    <p class="infoText">*请选择以上任意店铺</p>
    <div class="Market_main">
      <div class="pos_all">
        <div class="all_nav">
          <p>
            竞店 - {{ updataTime1.substring(5).replace("-", "月") }}日
            <i
              class="el-icon-warning-outline"
              style="font-size: 16px; margin-left: 15px"
              @click="showInfo"
            ></i>
          </p>
          <div class="showDate" v-show="showDate">
            <ul>
              <li>
                流量说明：各店维度流量为去重流量，故不等于各细分流量累计之和
              </li>
              <li>
                流量计算：流量为截至{{
                  updataTime1.substring(4).replace("-", "月")
                }}日流量累计之和
              </li>
            </ul>
          </div>
          <!-- <span>更新时间：{{ updataTime1 }}</span> -->
        </div>
        <Store :brandName="value2"></Store>
         <p class="infoImg el-icon-right"> 向右滑动查看更多</p>
      </div>
      <div class="pos_Tmall">
        <div class="Tmall_nav">
          <p>
            竞品 - {{ value2 }} - {{
              updataTime1.substring(5).replace("-", "月")
            }}日
          </p>
          <!-- <span>更新时间：{{ updataTime2 }}</span> -->
        </div>
        <Product :brandName="value2"></Product>
        <p class="infoImg el-icon-right"> 向右滑动查看更多</p>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import Product from "@/components/Market/product";
import Store from "@/components/Market/store";

export default {
  data() {
    return {
      showDate: false,
      value: "",
      value2: "",
      CategoryList: [],
      BrandList: [],
      updataTime1: "2020-05-19",
      updataTime2: "2020-05-19",
      brandName: "",
    };
  },
  methods: {
    showInfo() {
      this.showDate = !this.showDate;
    },
    changeType(value) {
      this.value = value;
      this.getBrand();
    },
    changeTop(value2) {
      this.value2 = value2;
    },
    getCategory() {
      this.$addr.post("/Sales/getCategory").then((res) => {
        this.CategoryList = [];
        this.value = "";
        this.value = res.data.data[0].categoryEn;
        res.data.data.map((item, index) => {
          this.CategoryList.push({
            text: item.categoryEn,
            value: item.categoryEn,
          });
        });
        this.getBrand();
      });
    },
    getUpdateDate() {
      this.$addr.post("/Sales/getUpdateDate").then((res) => {
        this.updataTime1 = res.data.data[0].competeUpdate;
      });
    },
    getBrand() {
      this.$addr
        .post("/Sales/getBrandName", qs.stringify({ categoryEn: this.value }))
        .then((res) => {
          this.BrandList = [];
          this.value2 = "";
          this.value2 = res.data.data[0].brandName;
          res.data.data.map((item, index) => {
            this.BrandList.push({
              text: item.brandName,
              value: item.brandName,
            });
          });
        });
    },
  },
  components: {
    Product,
    Store,
  },
  created() {
    this.getCategory();
    this.getUpdateDate();
  },
};
</script>
<style scoped>
.infoImg {
  font-family: "SourceHanSansCN-Medium";
  font-size: 13px;
  color: #9d9dd4;
  letter-spacing: 0;
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 10px;
}
/* .infoImg::before {
  position: absolute;
  left: -13px;
  bottom: 2px;
  content: "";
  width: 10px;
  height: 10px;
  background: url("../../assets/jpg/Group7.png") no-repeat;
  background-size: cover;
} */
.infoText {
  position: absolute;
  top: 45px;
  left: 10px;
  font-size: 12px;
  z-index: 99;
  font-family: "SourceHanSansCN-Normal";
  color: #555555;
}
.showDate {
  padding: 20px;
  font-family: "PingFangSC-Light";
  font-size: 10px;
  color: #191919;
  border: 1px solid black;
  z-index: 4;
  position: absolute;
  top: 40px;
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 20px;
  width: 90%;
}
ul li {
  margin-bottom: 2px;
  font-size: 10px;
  color: #191919;
  width: 100%;
  height: 20px;
  white-space: nowrap; /* 强制不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(157, 157, 157, 0.4);
  line-height: 20px;
}
.MarketMain {
  padding: 15px;
  background-color: rgb(245, 245, 251);
}
.Market_main .all_nav,
.Market_main .Tmall_nav,
.Market_main .stage_nav {
  position: relative;
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #d1534b;
  border-radius: 22.5008px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Market_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "PingFangSC-Medium";
  font-size: 16px;
  color: #ffffff;
}

.Market_main .all_nav span,
.Tmall_nav span,
.stage_nav span {
  opacity: 0.6;
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color: #f3f3f3;
  text-align: center;
  margin-right: 15px;
}

.Market_main .pos_all {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.Market_main .pos_Tmall {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.listSel2,
.listSel {
  width: 50%;
  display: flex;
  align-items: center;

  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  line-height: 14px;
}
.MylistSel {
  width: 50%;
}
.MylistSel2 {
  width: 50%;
}
.MylistSel2 .van-dropdown-menu {
  width: 50% !important;
}
.MylistSel .van-dropdown-menu {
  width: 50% !important;
}
.MylistSel .van-dropdown-menu /deep/ .van-popup--top {
  width: 27% !important;
  left: 21.5% !important;
}
.MylistSel2 .van-dropdown-menu /deep/ .van-popup--top {
  width: 27% !important;
  left: 21.5% !important;
}

.listSel2 .van-dropdown-menu {
  z-index: 7;
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 70%;
  height: 20px;
  position: relative;
  left: 10px;
}

.listSel .van-dropdown-menu {
  z-index: 7;
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 70%;
  height: 20px;
  position: relative;
  left: 10px;
}
.listSel .van-dropdown-menu /deep/ .van-popup--top {
  width: 33%;
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  left: 12.5% !important;
}

.listSel2 .van-dropdown-menu /deep/ .van-popup--top {
  width: 33%;
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  left: 59% !important;
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #555555;
}
/deep/ .van-dropdown-menu__title::after {
  text-align: right;
  border-color: transparent transparent #555555 #555555;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}
/deep/ .van-dropdown-menu__bar{
  height: 100%;
  background:  none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Market/IndexMarket.vue